import { Text } from '@/components/ui/text'
import type { Tables } from '@hvf/contracts'
import { Star } from 'lucide-solid'
import { Show } from 'solid-js'
import { Flex } from 'styled-system/jsx'
import { useSetupScores } from './SetupCommanderScore'

export const CommunityScore = (props: { setup: Tables<'setup'> | undefined }) => {
  const q = useSetupScores(() => props.setup?.id)

  const score = () => {
    const val = q.data?.community_score ?? 0
    return Number.isInteger(val) ? val : val.toFixed(1)
  }

  return (
    <Show
      when={(q.data?.community_scores_count ?? 0) > 0}
      fallback={<Text fontSize='14.5px' fontWeight='700' color='editorialInk3'>-</Text>}
    >
      <Flex alignItems='center' gap='4px'>
        <Text fontSize='13px' fontWeight='600' color='editorialInk3'>({q.data?.community_scores_count})</Text>
        <Star size={15} fill='var(--colors-editorial-star)' stroke='var(--colors-editorial-star)' />
        <Text fontSize='14.5px' fontWeight='700' color='editorialInk'>{score()}</Text>
      </Flex>
    </Show>
  )
}
